import React from "react";
import { Container, Row, Col, Card } from "react-bootstrap";
import { ArrowRepeat, Person, BookmarkStar } from "react-bootstrap-icons";

const SalesProblemSection = () => {
  return (
    <section className="mt-5" style={{ background: "#f8f9fc", padding: "80px 0" }}>
      <Container>
        {/* Heading */}
        <Row className="text-center mb-5">
          <Col>
            <h1 style={{ fontWeight: "700", color: "#111" }}>
              Traditional Sales & Support are Broken.
            </h1>
          </Col>
        </Row>

        {/* Cards */}
        <Row className="g-4">
          {/* Card 1 */}
          <Col md={4}>
            <Card className="border-0 shadow-lg h-100 text-center p-4 rounded-5">
              <div className="icon-box mb-3 mx-auto">
                <BookmarkStar size={34} color="#ffc107" />
              </div>

              <h3 className="fw-bold">High Return Rates</h3>
              <p className="text-muted">
                Customers can’t visualize products in their actual space.
              </p>
            </Card>
          </Col>

          {/* Card 2 */}
          <Col md={4}>
            <Card className="border-0 shadow-lg h-100 text-center p-4 rounded-5">
              <div className="icon-box mb-3 mx-auto">
                <ArrowRepeat size={34} color="#ff4d4f" />
              </div>

              <h3 className="fw-bold">Complex Sales Cycles</h3>
              <p className="text-muted">
                Technical products are hard to explain with 2D images.
              </p>
            </Card>
          </Col>

          {/* Card 3 */}
          <Col md={4}>
            <Card className="border-0 shadow-lg h-100 text-center p-4 rounded-5">
              <div className="icon-box mb-3 mx-auto">
                <Person size={34} color="#20c997" />
              </div>

              <h3 className="fw-bold">Support Bottlenecks</h3>
              <p className="text-muted">
                Manuals are outdated, and phone support is slow.
              </p>
            </Card>
          </Col>
        </Row>
      </Container>

      {/* Custom Styling */}
      <style jsx>{`
        .icon-box {
          width: 70px;
          height: 70px;
          background: #ffffff;
          display: flex;
          align-items: center;
          justify-content: center;
          border-radius: 18px;
          box-shadow: 0 10px 25px rgba(0, 0, 0, 0.08);
        }

        .card:hover {
          transform: translateY(-8px);
          transition: 0.3s ease;
        }
      `}</style>
    </section>
  );
};

export default SalesProblemSection;